export default __webpack_public_path__ + "static/media/flag.64f4888d.svg";